import { Box, SxProps, Theme, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { FC, ReactNode } from 'react';
import Info from '../Info/Info';

interface HeaderProps {
  title: string | ReactNode;
  description?: string;
  info?: ReactNode;
  sx?: SxProps<Theme>;
  variant?: Variant;
}

const Header: FC<HeaderProps> = ({
  title,
  description,
  info,
  variant = 'h5',
  sx = {},
}) => {
  return (
    <Box component='header' sx={{ mb: 2, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Typography variant={variant}>{title}</Typography>
        {info && <Info title={info} />}
      </Box>
      {description && (
        <Typography variant='body2' color='GrayText' sx={{ mt: 0.25 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
};
export default Header;
